// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"f9b4fb88","336":"70b2bb84"}[chunkId] + ".chunk.css";
};